import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import Pricecalculator from '../../Components/pricecalculator';
import BuyButton from '../../Components/BuyButton';
import ProductTierPriceContainer from './ProductTierPriceContainer';
import Square from '../Square';
import Circle from '../Circle';
import Triangle from '../Triangle';
import ShoppingListButton from '../ShoppingListButton';
import ProductChainIcon from './ProductChainIcon'
import StoreList from '../StoreList';
import Popup from '../Popup';
import { getClickCollectOrgs } from '../../Actions/GetClickCollectOrgs.action';
import { googleAnalytics } from '../../Services/googleAnalytics';
import { updatePreferredClickCollectAddress } from '../../Actions/PreferredClickCollectAddress.action';

const ListViewProductItem = (props) => {
  const hideShoppingList = window.__litium.constants.hideShoppingList;
  const showBuyButtons = window.__litium.constants.showBuyButtons;
  const {hidePrices} = window.__litium.channelConfig;
  const [isOpenStoreList, setOpenStoreList] = useState(false);
  const [store, setStore] = useState(null);

  const quantityUpdate = (fieldId, minValue, value) => {
    var fieldId = document.getElementById(fieldId);
    fieldId.value = parseInt(fieldId.value) + value;
    if (fieldId.value <= 0) {
      fieldId.value = minValue;
    }
  };

  const {
    authenticated,
    products,
    product,
    isChassiSearch,
    totalPriceCount,
    trClassName,
    isClickAndCollect
  } = props;

  const dispatch = useDispatch();
  const stores = useSelector((state) => state.clickCollectOrgs);
    
  const handleOpenPopup = () => {
    setOpenStoreList(true);
    dispatch(getClickCollectOrgs(product.Id))
  }

  useEffect(() => {
    let preffStore = JSON.parse(window.localStorage.getItem("preferedaddress"));
    let clickStore = JSON.parse(window.localStorage.getItem("preferredclickcollectaddress"));
    
    if(store == null && preffStore && preffStore.productAssortment?.includes("active")&& reRender){

      let streetAddress = preffStore.streetName;
      streetAddress += preffStore.zipCode ? " " + preffStore.zipCode : "";
      streetAddress += preffStore.city ? " " + preffStore.city : "";

      let store = {
        organizationId: preffStore.organizationId,
        organizationName: preffStore.companyName,
        email: preffStore.email,
        homePage: preffStore.homePage,
        address: streetAddress,
        productAssortment: preffStore.productAssortment,
        shopName: preffStore.name,
        longitude: preffStore.longitude,
        latitude: preffStore.latitude
      }
      setStore(store)
      setReRender(false)
      dispatch(updatePreferredClickCollectAddress(store));
    }
    else if(clickStore){
      setStore(clickStore);
    }

  },[isOpenStoreList])

  const hideDescription = props.hideDescription ? props.hideDescription : false;
  
  /*const showStockStatus =
    !product.StockStatus &&
    products &&
    products.length > 0 &&
    products.some((x) => x.StockStatus); OLD LOGIC*/

    const showStockStatus = products.some((x => x.ShouldShowStockStatus))

  const specificationTitles =
    products && products.length < 1
      ? null
      : products[0].SpecificationForProductPage;

  return (
    <Fragment>
      <tr
        itemScope
        itemType="http://schema.org/Product"
        className={
          product.IsExpired
            ? 'product-list-view product-list-view--expired ' + trClassName
            : 'product-list-view ' + trClassName
        }
      >
        <td aria-label={product.Name}>
          <figure className="product__figure">
            <a href={product.Url} title={product.Name}>
              <div dangerouslySetInnerHTML={{ __html: product.ImageUrl }}></div>
            </a>
          </figure>
        </td>
        {isChassiSearch == true && (
          <td>
            {product.Id}
            {product.HasChildOrIsChild == true && (
              <ProductChainIcon product={product} />
            )}
          </td>
        )}
        <td aria-label={product.Name} className="name">
          <a href={product.Url} title={product.Name}>
            {product.Name}
          </a>
          <div className="product__description-list">
            {hideDescription == false && product.Description} {hideDescription == false && translate('product.shortenedarticlenumber')} {hideDescription == false && product.Id}  
          </div>
        </td>
       
        {product.SpecificationForProductPage &&
          product.SpecificationForProductPage.map((specification, index) => (
            <td className="value spec" key={'ProSpec' + index}>
              {specification.Value ? specification.Value : ''}
              {product.HasChildOrIsChild == true && specification.IsArticleNumber == true && (
                <ProductChainIcon product={product} />
              )}
            </td>
          ))}
        {(!product.SpecificationForProductPage ||
          product.SpecificationForProductPage.length == 0) &&
          specificationTitles &&
          specificationTitles.length > 0 &&
          specificationTitles.map((title, index) => (
            <td className="value" key={'ProSpec' + index}>
            </td>
          ))}
        {!hidePrices && totalPriceCount && (
          <td>
            {product.IsExpired == false &&
              product.Price &&
              product.Price.TierPrices &&
              product.Price.TierPrices.length > 1 && (
                <div className="grid-tier-price list-view">
                  <ProductTierPriceContainer
                    product={JSON.stringify(product)}
                  />
                </div>
              )}
          </td>
        )}
        {product.StockStatus && !isClickAndCollect && (
          <td>
            {product.StockStatus == 'triangle' && <Triangle></Triangle>}
            {product.StockStatus == 'circle' && <Circle></Circle>}
            {product.StockStatus == 'square' && (
              <Square quantity={product.QuantityInStock}></Square>
            )}
          </td>
        )}
        {isClickAndCollect && showStockStatus &&
        <td className="stores-link">
          {product.IsInStock ? (
            <a 
              tabIndex={0}
              className="product__stock-infolistview test" 
              title={product.Name} 
              onClick={() => {
                googleAnalytics({'event': 'clickAndCollectOpenStoreSelect'})
                handleOpenPopup(product.Id)
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  googleAnalytics({ event: 'clickAndCollectOpenStoreSelect' });
                  handleOpenPopup(product.Id);
                }
              }}
            >
              {translate('product.isinstock')} <span className="product__stock-info--textcolor">{translate('product.showstores')}</span>
            </a>
          ) : (
            <div className="product__stock-infolistview">{translate('product.isnotinstock')}</div>
          )}
          <Popup
              isOpen={isOpenStoreList}
              setOpen={setOpenStoreList}
              component={
                <StoreList store={store} setStore={setStore} stores={stores.organizations} closeModal={() => setOpenStoreList(false)}></StoreList>
              }
            ></Popup>
        </td>
        }
        {!showStockStatus && <td></td>}
        {!product.IsExpired && (
          <Fragment>
            {!hidePrices && (
            <td>
              <Pricecalculator
                isauthorized={authenticated?.toString()?.toLowerCase() === 'true'}
                netpricincludingvat={product.NetPriceIncludingVAT}
                netpriceexcludingvat={product.NetPrice}
                recommendedpriceexcludingvat={product.RecommendedPrice}
                recommendedpriceincludingvat={product.RecommendedPriceIncludingVAT}
                campaignpriceincludingvat={product.CampaignPriceIncludingVAT}
                campaignprice={product.CampaignPrice}
              />
            </td>
            )}
            <td>
              <div className="list-view--actions">
                {props.isClickAndCollect ? (
                    <BuyButton
                      articleNumber={product.Id}
                      minValue={product.Price_Multiple}
                      cssClass={
                        product.EnableBuyButton
                          ? 'button buy-button product__buy-button list-buy-button button-padding'
                          : 'button buy-button product__buy-button list-buy-button button-padding disabled'
                      }
                      label={translate('button.addtocart')}
                      quantityFieldId=""
                    >
                      <span className='easyline__span'>
                        <a className='button buy-button product__buy-button easyline__buy-button'>
                          {translate('button.addtocart')}
                        </a>
                      </span>
                    </BuyButton>
                  ) : (
                    <div className="checkout-cart__quantity">
                      <span
                        className="controller"
                        onClick={() =>
                          quantityUpdate(
                            product.QuantityFieldId,
                            product.Price_Multiple,
                            product.Price_Multiple > 1
                              ? -1 * product.Price_Multiple
                              : -1
                          )
                        }
                      >
                        -
                      </span>
                      <input
                        id={product.QuantityFieldId}
                        type="number"
                        data-buy-quantity-input
                        defaultValue={product.Price_Multiple}
                        min={product.Price_Multiple}
                        max="999"
                        maxLength="3"
                        aria-label={translate('brenderup.accessibility.text.quantityinput')}
                        className="product__buy-quantity form__input"
                      />
                      <span
                        className="controller"
                        onClick={() =>
                          quantityUpdate(
                            product.QuantityFieldId,
                            product.Price_Multiple,
                            product.Price_Multiple > 1
                              ? 1 * product.Price_Multiple
                              : 1
                          )
                        }
                      >
                        +
                      </span>
                    </div>
                  )}

                {!hideShoppingList && (
                  <div className="shoppinglist-button">
                    <ShoppingListButton
                      productId={product.Id}
                      isSmall={true}
                      product={product}
                    ></ShoppingListButton>
                  </div>
                )}

                {showBuyButtons && (
                  <BuyButton
                    articleNumber={product.Id}
                    cssClass={
                      product.EnableBuyButton
                        ? 'button buy-button product__buy-button list-button  '
                        : 'button buy-button product__buy-button list-button disabled'
                    }
                    style={{ color: 'red' }}
                    quantityFieldId={product.QuantityFieldId}
                    aria-label={translate('button.addtocart')}
                    label={undefined}
                  />
                )}
              </div>
            </td>
          </Fragment>
        )}
        {product.IsExpired && (
          <td colSpan="3" align="right">
            <span className="product-list-view__replacement-text">
              {!product.AlternativeId && (
                <Fragment>{translate('replacementNotFoundLabel')}</Fragment>
              )}
              {product.AlternativeId && (
                <Fragment>
                  {translate(
                    product.ReplacementStatus == 'Never'
                      ? 'replacementProductLabel'
                      : 'similiarProductLabel'
                  )}{' '}
                  <a href={product.AlternativeURL}>{product.AlternativeId}</a>
                </Fragment>
              )}
            </span>
          </td>
        )}
      </tr>
    </Fragment>
  );
};

export default ListViewProductItem;